import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import * as constants from '../../constants';

import '../../public/css/index.css';
import NavbarItem from '../NavbarItem';
import SocialItem from '../SocialItem';
import profileImage from '../../public/img/head_shot.png';
// import PageNotFound from './404';

// Lazy load pages
const Home = lazy(() => import('./home'));
// eslint-disable-next-line no-unused-vars
const Contact = lazy(() => import('./contact'));
const Resume = lazy(() => import('./resume'));
const NotFound = lazy(() => import('./404'));

function IndexPage() {
  return (
    <div id="website-body">
      <div id="banner">
        <div id="spacer">
          <div id="imgWrapper">
            <img src={profileImage} className="profileImg" alt={constants.fullName} />
          </div>
        </div>
      </div>
      <div className="wrapper-main">
        <Router>
          <div className="navbar">
            <NavbarItem text="Home" to="/home" />
            <NavbarItem text="Resum&eacute;" to="/resume" />
            {/* <NavbarItem text="Contact Me" to="/contact"/> */}
          </div>
          <div id="socials-wrapper">
            <div id="socials-container">
              <SocialItem
                href={constants.socials.github}
                imgSrc='https://github.githubassets.com/pinned-octocat.svg'
                imgClassName='invertColor'
                imgAlt="GitHub Logo"
                handle="@Trenly"
              />
              <SocialItem
                href={constants.socials.linkedin}
                imgSrc='https://static-exp1.licdn.com/sc/h/akt4ae504epesldzj74dzred8'
                imgAlt="LinkedIn Logo"
                handle="kalebluedtke"
              />
              <SocialItem
                href={constants.socials.stackExchange}
                imgSrc='https://cdn.sstatic.net/Sites/stackexchange/Img/apple-touch-icon@2.png'
                imgAlt="StackExchange Logo"
                handle="@Trenly"
              />
            </div>
          </div>
          <div className="wrapper-content">
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/about" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<Home />} />
                <Route path="/resume" element={<Resume />} />
                {/* <Route path="/contact" element={<ContactPage />} /> */}
                <Route path="/*" element={<NotFound />} />
                {/* <Route path="/*" element={<PageNotFound />} /> */}
              </Routes>
            </Suspense>
          </div>
        </Router>
      </div>
      <div id="footer">
        <span>{constants.copyright}</span>
      </div>
    </div>
  );
}

export default IndexPage;
